'use client';

import {
  useUserDispatch,
  useUserState,
} from '@/components/context/UserContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { MaterialIcon } from '@/components/ui/shared/materialIcon';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogBody,
} from '@/components/ui/dialog';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import useFetch from 'use-http';

export default function DelegatesAndConsents() {
  const history = useHistory();
  const userState = useUserState();
  const [showConsentWarning, setShowConsentWarning] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showConsentUpdateDialog, setShowConsentUpdateDialog] = useState(false);
  // Example variable (replace with your real condition)
  const { post: postAgreementsRequest, response: postAgreementsResponse } =
    useFetch(`/UserAccount/UpdateAgreement`);
  const marketingConsentId =
    process.env.REACT_APP_AGREEMENTS_MARKETING_CONSENT_EXTID;
  const { get: getAgreementsRequest, response: getAgreementsRequestResponse } =
    useFetch(`/UserAccount/Agreements`);

  useEffect(() => {
    setShowConsentWarning(
      !userState?.discountByCardApplicable && userState?.discountCard,
    );
  }, []);

  const sessionDispatch = useUserDispatch();

  const handleConsentAgreement = async () => {
    setLoading(true);
    await getAgreementsRequest(
      userState.espbiEsi ? `?espbiEsi=${userState.espbiEsi}` : '',
    );
    const response = await getAgreementsRequestResponse;

    const consent = response?.data?.consents.find(
      (x) => x.consentId == marketingConsentId,
    );
    if (consent) {
      let objTrimmedChangesArray = [
        {
          medConsultPersonGuid: userState.id,
          patientConsentId: consent.id,
          value: true,
          consentId: consent.consentId,
          espbiEsi: userState.espbiEsi,
        },
      ];

      const updateResponse = await postAgreementsRequest(
        ' ',
        objTrimmedChangesArray,
      );
      sessionDispatch({
        type: 'UPDATE',
        data: {
          discountByCardApplicable: true,
        },
      });
      setShowConsentUpdateDialog(false);
      setShowConsentWarning(false);
    }
    setLoading(false);
  };

  return (
    <Card>
      <CardHeader className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-y-2">
          <Heading variant="userAccountTitle">
            Įgalioti asmenys ir rinkodaros sutikimai
          </Heading>
        </div>
        <Button
          type="submit"
          variant="light"
          onClick={() =>
            history.push('/userAccount/personal-info/manage-agreements')
          }
        >
          <MaterialIcon icon="edit" size={16} />
          Redaguoti
        </Button>
      </CardHeader>

      {showConsentWarning && (
        <CardContent className="mt-2 w-full">
          <div className="w-full rounded-xl">
            <div className="flex items-start gap-2 bg-red-50 border border-red-200 p-3 rounded">
              <MaterialIcon icon="error" size={20} className="text-red-600" />
              <p className="text-red-600 text-sm font-medium break-words">
                {userState?.consentExpired
                  ? 'Jūsų nuolaidų kortelei nėra taikomos nuolaidos, nes Jūsų rinkodaros sutikimo galiojimas pasibaigęs'
                  : 'Jūsų nuolaidų kortelei nėra taikomos nuolaidos, nes Jūs nepatvirtinote rinkodaros sutikimo'}
              </p>
            </div>
            <div className="mt-3 mb-3 w-full flex justify-center">
              <Button
                variant="light"
                className="w-full md:w-1/4 sm:w-2/4 max-w-full whitespace-normal text-center break-words"
                onClick={() => setShowConsentUpdateDialog(true)}
              >
                Peržiūrėti ir patvirtinti sutikimą
              </Button>
            </div>
          </div>
        </CardContent>
      )}

      <Dialog
        open={showConsentUpdateDialog}
        onOpenChange={setShowConsentUpdateDialog}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Rinkodaros sutikimas</DialogTitle>
          </DialogHeader>
          <DialogBody>
            Sutinku gauti priminimus apie profilaktines patikras, tyrimus ir
            skiepus, aktualiausias naujienas apie moderniausius gydymo ir
            diagnostikos metodus bei man pritaikytą informaciją apie Affidea
            įmonių grupės paslaugų pasiūlymus.
          </DialogBody>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => setShowConsentUpdateDialog(false)}
            >
              Atsisakyti
            </Button>
            <Button
              variant="secondary"
              loading={loading}
              onClick={handleConsentAgreement}
            >
              Patvirtinti
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Card>
  );
}
